import PropTypes from 'prop-types';
import React from 'react';

const MRIIcon = ({ title = 'Magnetröntgen Ikon', titleId, ...props }) => (
	<svg
		aria-labelledby={titleId}
		fill="currentColor"
		height="1em"
		width="1em"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		{title ? <title id={titleId}>{title}</title> : null}
		<path
			d="M12 2c4.985 0 9 4.102 9 9.128a9.161 9.161 0 0 1-2.953 6.757l.386 1.664a2 2 0 0 1-1.711 2.437l-.238.014H7.516l-.238-.014a2.001 2.001 0 0 1-1.75-2.203l.04-.234.384-1.667A9.16 9.16 0 0 1 3 11.128C3 6.102 7.015 2 12 2ZM7.747 19h8.506l-1.389-6H9.136l-1.389 6ZM12 4c-3.851 0-7 3.177-7 7.128 0 1.663.561 3.19 1.497 4.4l.69-2.98a2 2 0 0 1 1.776-1.54L9.136 11h5.728l.173.008a2 2 0 0 1 1.777 1.54l.689 2.982A7.176 7.176 0 0 0 19 11.128C19 7.177 15.851 4 12 4Z"
			fill="#000"
		/>
	</svg>
);

MRIIcon.propTypes = {
	title: PropTypes.string,
	titleId: PropTypes.string,
};

export default MRIIcon;
